import React, { useEffect, useRef } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { luxColors, Icon, Iffy } from '../..';
const styles = StyleSheet.create({
    removeButton: {
        alignSelf: 'flex-start',
        paddingTop: 10,
        paddingLeft: 10,
        paddingBottom: 10,
        paddingRight: 8,
    },
    removeIcon: {
        width: 20,
        height: 20,
        color: luxColors.toastRemoveButton.primary,
    },
    toastWrapperStyle: {
        backgroundColor: luxColors.toastBackground.primary,
        borderRadius: 1,
        maxWidth: 350,
        marginTop: 16,
        display: 'flex',
        flexDirection: 'row-reverse',
        position: 'relative',
        paddingRight: 10,
        paddingLeft: 15,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    childrenWrapper: {
        flex: 1,
    },
});
const Toast = ({ children, remove, removable, timeoutMs, }) => {
    const removeRef = useRef(null);
    removeRef.current = remove;
    useEffect(() => {
        const duration = timeoutMs;
        if (timeoutMs > 0) {
            const id = setTimeout(() => {
                if (removeRef.current) {
                    // @ts-ignore
                    removeRef.current();
                }
            }, duration);
            return () => clearTimeout(id);
        }
    }, []);
    return (<View style={styles.toastWrapperStyle}>
      <Iffy is={removable}>
        <View testID="icon-close" style={styles.removeButton}>
          <TouchableOpacity onPress={remove}>
            <Icon name="window-close" style={styles.removeIcon}/>
          </TouchableOpacity>
        </View>
      </Iffy>
      <View style={styles.childrenWrapper}>
        {children}
      </View>
    </View>);
};
export default Toast;
//# sourceMappingURL=Toast.js.map